import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { es } from "./es.js";
import { en } from "./en.js";
import { tr } from "./tr.js";

let translations = { en: en, es: es, tr: tr };

let languageDetectorOptions = {
  // querystring first: an explicit `?lng=` param (e.g. the console passing the
  // user's current language when opening this editor) must win over whatever
  // was cached from a previous visit. It still gets cached to localStorage
  // below, so subsequent navigations without the param keep using it.
  order: ["querystring", "localStorage", "navigator", "cookie", "htmlTag"],
  lookupLocalStorage: "i18nextLng",
  lookupCookie: "i18next",
  caches: ["localStorage"],
};

i18n.use(LanguageDetector).init({
  whitelist: ["en", "es", "tr"],
  fallbackLng: "tr",
  attributes: ["t", "i18n"],
  resources: translations,
  debug: false,
  detection: languageDetectorOptions,
  load: "languageOnly",
  nonExplicitWhitelist: true,
});

export default i18n;
